import LoadingSpinner from "@app/shared/LoadingSpinner";
import { FC, useState, useEffect, JSX, Fragment } from "react";
import TemplateService from "@app/admin/manage-templates/templateService";
import moment from "moment";
import { SpecialtyComment } from "@app/admin/manage-specialties";
import { TemplateHistoryModel } from "@app/admin/manage-templates/template";
import { TimelineEvent } from "@app/shared/timeline/TimelineEvent";
import { Timeline } from "@app/shared/timeline/Timeline";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QesColors } from "@app/shared/qes-standards/colors";

interface TemplateHistoryFlyoutProps {
  correlationId: string;
  templateCollectionId: number;
}

const TemplateHistoryFlyout: FC<TemplateHistoryFlyoutProps> = ({ correlationId, templateCollectionId }: TemplateHistoryFlyoutProps): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(true);
  const [templateHistory, setTemplateHistory] = useState<TemplateHistoryModel>();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const templateService = new TemplateService();
      const data = await templateService.getTemplateHistory(templateCollectionId, correlationId);
      setTemplateHistory(data);
      setLoading(false);
    }

    fetchData();
  }, []);

  const formatDate = ((dateString: string) => {
    const dateFormat: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      hour: 'numeric',
      hour12: true,
      minute: 'numeric',
      month: 'long',
      year: 'numeric'
    }
    const offset = new Date().getTimezoneOffset();
    const dateToFormat = new Date(dateString);
    dateToFormat.setMinutes(dateToFormat.getMinutes() - offset);
    return Intl.DateTimeFormat("en-US", dateFormat).format(dateToFormat);
  });

  return (
    loading ? <LoadingSpinner /> :
      !templateHistory ? null :
        <>
          <Timeline>
            {templateHistory.events
              .sort((a, b) => moment(b.displayDate).unix() - moment(a.displayDate).unix())
              .map((templateEvent, i) => {
                try {
                  const comments: SpecialtyComment[] = JSON.parse(templateEvent.comment)
                  return (
                    <Fragment key={i}>
                      {comments.map((comment, j) => (
                        <TimelineEvent
                          key={j}
                          title={`${templateEvent.eventDescription} by ${templateEvent.user} on`}
                          subtitle={formatDate(templateEvent.displayDate)}
                          icon={<QesIcon iconName={QesIcons.CheckCircle} color={QesColors.QesPrimaryGreen} width="22px" isDecorative />}
                          size="small"
                        >
                          {!templateEvent.comment ? null :
                            <>
                              <div style={{ fontWeight: 'bold' }}>Comments:</div>
                              <div style={{ whiteSpace: 'pre-wrap' }}>{`${comment.actionTaken} ${comment.specialtyName} specialty `}</div>
                            </>
                          }
                        </TimelineEvent>
                      ))}
                    </Fragment>
                  )
                } catch (e) {
                  return (
                    <Fragment key={i}>
                      <TimelineEvent
                        title={`${templateEvent.eventDescription} by ${templateEvent.user} on`}
                        subtitle={formatDate(templateEvent.displayDate)}
                        icon={<QesIcon iconName={QesIcons.CheckCircle} color={QesColors.QesPrimaryGreen} width="22px" isDecorative />}
                        size="small"
                      >
                        {!templateEvent.comment ? null :
                          <>
                            <div style={{ fontWeight: 'bold' }}>Comments:</div>
                            <div style={{ whiteSpace: 'pre-wrap' }}>{templateEvent.comment}</div>
                          </>
                        }
                      </TimelineEvent>
                    </Fragment>
                  )
                }
              })}
          </Timeline>
        </>
  );
};

export default TemplateHistoryFlyout;